import { ACCEPTANCE_CRITERIA_OPTION, ShiftPostStep } from '@features/shift-post-v2/steps'
import {
  PositionNameSection,
  ShiftIdentifierNumbersSection,
} from '@features/shift-post-v2/steps/shift-details-step/components'
import { LocationSection } from '@features/shift-post-v2/steps/shift-details-step/components'
import { UpshiftersNumberSection } from '@features/shift-post-v2/steps/shift-details-step/components'
import { ScheduleSection } from '@features/shift-post-v2/steps/shift-details-step/components'
import { WhoCanWorkSection } from '@features/shift-post-v2/steps/acceptance-criteria-step/components'
import { InviteUpshiftersSection } from '@features/shift-post-v2/steps/invite-upshifters-step/components'
import { ScreeningSection } from '@features/shift-post-v2/steps/screening-requirements-step/components'
import { useSelector } from 'react-redux'
import { selectBusinessEntity } from '@src/data/BusinessEntity/selectors'
import { connect } from 'formik'
import { useMemo } from 'react'
import { getSelectedAcceptanceCriteriaOption } from '../../utils'
import { IConfirmStepProps } from './confirm-step.types'
import { EstimatedTotalSection } from './components'
import { ConfirmStepContainer } from './confirm-step.styles'

export const ConfirmStep = connect<IConfirmStepProps>(
  ({ sourcePage, shouldRenderAutoAcceptCertificates = true, formik }) => {
    const { values } = formik
    const businessEntity = useSelector(selectBusinessEntity)
    const isRostersEnabled = businessEntity?.business_setting?.rosters_enabled
    const hasAutoAcceptNowButShiftDidNot = businessEntity?.auto_accept && !values.auto_accept

    const selectedAcceptanceCriteriaOption = useMemo(
      () =>
        getSelectedAcceptanceCriteriaOption(
          values.auto_accept_by_rosters,
          values.auto_accept,
          hasAutoAcceptNowButShiftDidNot ?? false
        ),
      [values.auto_accept_by_rosters, values.auto_accept, hasAutoAcceptNowButShiftDidNot]
    )

    const isAutoAccept =
      selectedAcceptanceCriteriaOption !== ACCEPTANCE_CRITERIA_OPTION.PERSONALLY_APPROVED

    return (
      <ConfirmStepContainer>
        <PositionNameSection sourceStep={ShiftPostStep.CONFIRM} sourcePage={sourcePage} />
        <LocationSection sourceStep={ShiftPostStep.CONFIRM} sourcePage={sourcePage} />
        <UpshiftersNumberSection sourceStep={ShiftPostStep.CONFIRM} sourcePage={sourcePage} />
        {businessEntity?.enabled_gig_identifier_policy && (
          <ShiftIdentifierNumbersSection
            sourceStep={ShiftPostStep.CONFIRM}
            sourcePage={sourcePage}
          />
        )}
        <ScheduleSection sourceStep={ShiftPostStep.CONFIRM} sourcePage={sourcePage} />
        <WhoCanWorkSection sourceStep={ShiftPostStep.CONFIRM} sourcePage={sourcePage} />
        {shouldRenderAutoAcceptCertificates && isAutoAccept && (
          <ScreeningSection sourceStep={ShiftPostStep.CONFIRM} sourcePage={sourcePage} />
        )}
        {isRostersEnabled && (
          <InviteUpshiftersSection sourceStep={ShiftPostStep.CONFIRM} sourcePage={sourcePage} />
        )}
        <EstimatedTotalSection sourceStep={ShiftPostStep.CONFIRM} sourcePage={sourcePage} />
      </ConfirmStepContainer>
    )
  }
)
